import repository from "@/api/modules/Sales/SalesOrders/index";

export default {
  state: {
    result: null,
    STATUS: [
      "saved",
      "for sales",
      "for accounting",
      "approved",
      "completed",
      "rejected",
      "canceled",
      "deleted",
      "converted",
      "exec approved",
      "partial",
      "for exec approval",
      "for cleanup",
      "for credit limit",
      "for credit terms",
      "for scheduling",
      "waiting for stocks",
      "preparing",
      "prepared",
      "checking",
      "checked",
      "invoiced",
    ],
    REFRESH: false,
    printNoOfLines: 27,
    can_approve_sales_orders: false,
    can_accounting_approve_sales_orders: false,
    can_exec_approve_sales_orders: false,
    sales_order_approval_settings: {
      bypasses: [],
      sales_approvers: [],
      accounting_approvers: [],
      exec_approvers: [],
      users: [],
    },
  },
  getters: {
    GET_RESULT: (state) => state.result,
    SALES_ORDERS: (state) => state,
    PRINT_NO_OF_LINES: (state) => state.printNoOfLines,
    GET_CAN_APPROVE_SALES_ORDERS: (state) => state.can_approve_sales_orders,
    GET_CAN_ACCOUNTING_APPROVE_SALES_ORDERS: (state) => state.can_accounting_approve_sales_orders,
    GET_CAN_EXEC_APPROVE_SALES_ORDERS: (state) => state.can_exec_approve_sales_orders,
    GET_SALES_ORDER_APPROVAL_SETTINGS: (state) => state.sales_order_approval_settings,
  },
  actions: {
    salesOrdersPut({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .salesOrdersPut(payload)
          .then((response) => {
            if (response.status == 200) {
              commit("RESULT");
              commit("REFRESH", true);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    salesOrdersPost({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .salesOrdersPost(payload)
          .then((response) => {
            if (response.status == 200) {
              commit("RESULT");
              commit("REFRESH", true);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    salesOrdersGet({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .salesOrdersGet(payload)
          .then((response) => {
            if (response.status == 200) {
              commit("RESULT");
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    salesOrdersDelete({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .salesOrdersDelete(payload)
          .then((response) => {
            if (response.status == 200) {
              commit("RESULT");
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchCanApproveSalesOrders({ commit }) {
      return new Promise((resolve) => {
        repository
          .canApproveSalesOrders()
          .then((response) => {
            const canApprove = response.data.can_approve;
            const canAccountingApprove = response.data.can_accounting_approve;
            const canExecApprove = response.data.can_exec_approve;
            commit("CAN_APPROVE_SALES_ORDERS", canApprove);
            commit("CAN_ACCOUNTING_APPROVE_SALES_ORDERS", canAccountingApprove);
            commit("CAN_EXEC_APPROVE_SALES_ORDERS", canExecApprove);
            resolve({
              can_approve: canApprove,
              can_accounting_approve: canAccountingApprove,
              can_exec_approve: canExecApprove,
            });
          })
          .catch(() => {
            commit("CAN_APPROVE_SALES_ORDERS", false);
            commit("CAN_ACCOUNTING_APPROVE_SALES_ORDERS", false);
            commit("CAN_EXEC_APPROVE_SALES_ORDERS", false);
            resolve({ can_approve: false, can_accounting_approve: false, can_exec_approve: false });
          });
      });
    },
    getSalesOrderApprovalSettings({ commit }) {
      return new Promise((resolve, reject) => {
        repository
          .getSalesOrderApprovalSettings()
          .then((response) => {
            commit("SALES_ORDER_APPROVAL_SETTINGS", response.data);
            resolve(response.data);
          })
          .catch(reject);
      });
    },
    storeSalesOrderApprovalBypass({ commit }, payload) {
      return repository.storeSalesOrderApprovalBypass(payload);
    },
    updateSalesOrderApprovalBypass({ commit }, { id, payload }) {
      return repository.updateSalesOrderApprovalBypass(id, payload);
    },
    destroySalesOrderApprovalBypass({ commit }, id) {
      return repository.destroySalesOrderApprovalBypass(id);
    },
    storeSalesOrderApprovalApprover({ commit }, payload) {
      return repository.storeSalesOrderApprovalApprover(payload);
    },
    updateSalesOrderApprovalApprover({ commit }, { id, payload }) {
      return repository.updateSalesOrderApprovalApprover(id, payload);
    },
    destroySalesOrderApprovalApprover({ commit }, id) {
      return repository.destroySalesOrderApprovalApprover(id);
    },
  },
  mutations: {
    RESULT: (state, data) => {
      state.result = data;
    },
    REFRESH: (state, data) => {
      state.REFRESH = data;
    },
    PRINT_NO_OF_LINES_UPDATE: (state, data) => {
      state.printNoOfLines = data;
    },
    CAN_APPROVE_SALES_ORDERS: (state, data) => {
      state.can_approve_sales_orders = data;
    },
    CAN_ACCOUNTING_APPROVE_SALES_ORDERS: (state, data) => {
      state.can_accounting_approve_sales_orders = data;
    },
    CAN_EXEC_APPROVE_SALES_ORDERS: (state, data) => {
      state.can_exec_approve_sales_orders = data;
    },
    SALES_ORDER_APPROVAL_SETTINGS: (state, data) => {
      state.sales_order_approval_settings = data;
    },
  },
};
